import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContactSearchBackButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));
